import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type {
  ListarPendenciasPublicacaoInput,
  PendenciasPublicacaoPagina,
} from '../../types/pendenciasPublicacaoTypes';

export async function listarPendenciasPublicacaoService({
  id,
  page = 1,
}: ListarPendenciasPublicacaoInput): Promise<PendenciasPublicacaoPagina> {
  const response = await apiGet(
    `/arbitral/painel/processos/${id}/pendencias/publicacao?page=${page}&limit=20`,
  );
  if (!response.ok) await throwApiError(response, 'Não foi possível conferir as pendências.');
  const result = await response.json();
  return result.data as PendenciasPublicacaoPagina;
}
